@if (category && category.icon) {
<img
  ngSrc="{{category.icon | fileurl}}"
  alt="{{category.name}} icon"
  width="128"
  height="128"
  class="animate__fadeIn animate__animated animate__faster"
/>
}
<div class="items">
  <a
    class="link"
    routerLink="/search"
    [queryParams]="{category_ids: category?.id}"
    >View All {{category?.name}}</a
  >
  <div class="subcategories">
    @for (child of category?.children; track $index) {
    <a
      class="link"
      routerLink="/search"
      [queryParams]="{category_ids: child.id}"
      ><span>{{child.name}}</span>

      <mat-icon fontSet="material-symbols-outlined" inline
        >arrow_forward_ios</mat-icon
      >
    </a>
    }
  </div>
</div>
